import React from 'react';
import reactDom from '../../../common/react/dom/index';
import PromoReportContainer from '../../../components/frontend/promoReport';

export default function init() {
	reactDom(<PromoReportContainer />, 'js-react-promo-report');
}
